module.exports = __webpack_public_path__ + "img/logo.dab40f65.png";